import { render, staticRenderFns } from "./roleSettingCom.vue?vue&type=template&id=d1c43f6a&"
import script from "./roleSettingCom.vue?vue&type=script&lang=tsx&"
export * from "./roleSettingCom.vue?vue&type=script&lang=tsx&"
import style0 from "./roleSettingCom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports